module.exports = __webpack_public_path__ + "img/banner_blendermarket.8389f453.png";